module.exports = __webpack_public_path__ + "static/media/elements_steptracker.03af5979.png";